import { fetchCurrentUser } from '../../ducks/user.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { retrieveSubscriptionPrice } from '../../ducks/stripe.duck';
import { getUserType } from '../../util/userDataExtraction';
import { StatusCode, SUBSCRIPTION_LOOKUP_BY_USETYPE } from '../../util/enums';
import { sendEmailNotification, SharetribeApi } from '../../util/api';
import { showErrorToast, showSuccessToast } from '../../util/toast';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/SubscriptionPage/SET_INITIAL_STATE';
export const SEND_AGENCY_PLUS_DATA_REQUEST = 'app/SubscriptionPage/SEND_AGENCY_PLUS_DATA_REQUEST';
export const SEND_AGENCY_PLUS_DATA_SUCCESS = 'app/SubscriptionPage/SEND_AGENCY_PLUS_DATA_SUCCESS';
export const SEND_AGENCY_PLUS_DATA_ERROR = 'app/SubscriptionPage/SEND_AGENCY_PLUS_DATA_ERROR';

export const UPDATE_SUBSCRIPTION_TYPE_REQUEST =
  'app/SubscriptionPage/UPDATE_SUBSCRIPTION_TYPE_REQUEST';
export const UPDATE_SUBSCRIPTION_TYPE_SUCCESS =
  'app/SubscriptionPage/UPDATE_SUBSCRIPTION_TYPE_SUCCESS';
export const UPDATE_SUBSCRIPTION_TYPE_ERROR = 'app/SubscriptionPage/UPDATE_SUBSCRIPTION_TYPE_ERROR';

// ================ Reducer ================ //

const initialState = {
  sendAgencyPlusDataInProgress: false,
  sendAgencyPlusDataError: null,
  updateSubscriptionTypeInProgress: false,
  updateSubscriptionTypeError: null,
};

export default function profilePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_STATE:
      return { ...initialState };
    case SEND_AGENCY_PLUS_DATA_REQUEST:
      return { ...state, sendAgencyPlusDataInProgress: true, sendAgencyPlusDataError: null };
    case SEND_AGENCY_PLUS_DATA_SUCCESS:
      return { ...state, sendAgencyPlusDataInProgress: false };
    case SEND_AGENCY_PLUS_DATA_ERROR:
      return { ...state, sendAgencyPlusDataInProgress: false, sendAgencyPlusDataError: payload };

    case UPDATE_SUBSCRIPTION_TYPE_REQUEST:
      return {
        ...state,
        updateSubscriptionTypeInProgress: true,
        updateSubscriptionTypeError: null,
      };
    case UPDATE_SUBSCRIPTION_TYPE_SUCCESS:
      return {
        ...state,
        updateSubscriptionTypeInProgress: false,
        updateSubscriptionTypeError: null,
      };
    case UPDATE_SUBSCRIPTION_TYPE_ERROR:
      return {
        ...state,
        updateSubscriptionTypeInProgress: false,
        updateSubscriptionTypeError: payload,
      };
    default:
      return state;
  }
}

// ================ Selectors ================ //
export const sendAgencyPlusDataSelector = state => {
  const { sendAgencyPlusDataInProgress, sendAgencyPlusDataError } = state.SubscriptionPage;
  return {
    sendAgencyPlusDataInProgress,
    sendAgencyPlusDataError,
  };
};

// ================ Action creators ================ //

export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});
export const sendAgencyPlusDataRequest = () => ({ type: SEND_AGENCY_PLUS_DATA_REQUEST });
export const sendAgencyPlusDataSuccess = () => ({
  type: SEND_AGENCY_PLUS_DATA_SUCCESS,
});
export const sendAgencyPlusDataError = error => ({
  type: SEND_AGENCY_PLUS_DATA_ERROR,
  error: true,
  payload: error,
});
export const updateSubscriptionTypeRequest = () => ({ type: UPDATE_SUBSCRIPTION_TYPE_REQUEST });
export const updateSubscriptionTypeSuccess = () => ({
  type: UPDATE_SUBSCRIPTION_TYPE_SUCCESS,
});
export const updateSubscriptionTypeError = error => ({
  type: UPDATE_SUBSCRIPTION_TYPE_ERROR,
  error: true,
  payload: error,
});

export const sendAgencyPlusData = params => async dispatch => {
  dispatch(sendAgencyPlusDataRequest());
  try {
    const response = await sendEmailNotification(params);
    if (response.statusCode === StatusCode.SUCCESS) {
      dispatch(sendAgencyPlusDataSuccess());
      showSuccessToast('Successfully sent email');
    }
  } catch (error) {
    showErrorToast('Error while sending email');
    dispatch(sendAgencyPlusDataError(storableError(error)));
  }
};
export const updateSubscriptionType = params => async (dispatch, getState, sdk) => {
  dispatch(updateSubscriptionTypeRequest());
  try {
    const response = await SharetribeApi.fetchAndUpdateListings(params);
    if (response.statusCode === StatusCode.SUCCESS) {
      dispatch(updateSubscriptionTypeSuccess());
    }
  } catch (error) {
    dispatch(updateSubscriptionTypeError(storableError(error)));
  }
};
// ================ Thunks ================ //

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  await dispatch(fetchCurrentUser());
  const currentUser = getState().user.currentUser;

  const userType = getUserType(currentUser);

  const lookupKeys = SUBSCRIPTION_LOOKUP_BY_USETYPE[userType] || null;

  // Clear state so that previously loaded data is not visible
  // in case this page load fails.
  dispatch(setInitialState());

  return Promise.all([dispatch(retrieveSubscriptionPrice({ lookupKeys }))]);
};
